export const brand = {
    name: "Qwiztime",
    logoText: "Qwiztime",
}

export const navLinks = [
    { label: "Quizzes",     href: "#quizzes" },
    { label: "Sample Quiz", href: "#sample"  },
    { label: "How it works", href: "#how"    },
]
